<template>
  <div class="add-black-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="450px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="80px">
        <el-form-item label="类型名称:" prop="replay">
          <el-input
            placeholder="请输入类型名称"
            v-model="params.fType"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型排序:" prop="replay">
          <el-input
            placeholder="类型排序"
            v-model.number="params.sortNum"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      flag: false,
      // 请求参数
      params: {
        id: undefined,
        fType: "",
        sortNum: "",
      },
      // 表单验证规则
      rules: {
        fType: [{ message: "请输入类型名称", trigger: "blur" }],
        sortNum: [{ message: "请输入排序", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.title == "编辑用户反馈类型") {
            this.flag = true;
            this.upDate();
          } else {
            this.addDate();
          }
        } else {
          return false;
        }
      });
    },
    // 新增类型
    addDate() {
      API.addFeedbackType(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.$emit("handlerAddblack");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑标签
    upDate() {
      API.updateFeedbackType(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("handlerAddblack");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        id: undefined,
        fType: "",
        sortNum: "",
      };
      this.$refs.form.resetFields();
    },
    // 打开编辑弹窗、传递需要编辑的参数
    open(type, row) {
      this.dialogVisible = true;
      if (type == "edit") {
        this.title = "编辑用户反馈类型";
        this.params = row;
      } else {
        this.title = "新增用户反馈类型";
      }
    },
  },
};
</script>

<style lang="scss"></style>
